import { ReportsAction, ReportsActionType } from './action-types';
import { IReportsState } from './types';

export const reportsReducerName = 'reportsReducer';
export const reportsInitialState: IReportsState = {
    data: null,
    hasError: false,
    errorMessage: null,
};

export function reportsReducer(
    prev: IReportsState = reportsInitialState, action: ReportsAction): IReportsState {
    switch (action.type) {
        case ReportsActionType.REQUEST_REPORT_LIST:
            return {
                ...prev,
                hasError: false,
                errorMessage: null,
            };

        case ReportsActionType.RECEIVE_REPORT_LIST: {
            return {
                ...prev,
                hasError: false,
                data: action.data,
                errorMessage: null,
            };
        }

        case ReportsActionType.RECEIVE_REPORT_LIST_ERROR:
            return {
                ...prev,
                hasError: true,
                errorMessage: action.errorMessage,
                data: null
            };

        default:
            return prev;
    }
}